import { render, staticRenderFns } from "./storage-img-uploader.vue?vue&type=template&id=74d5fbf4&scoped=true&"
import script from "./storage-img-uploader.vue?vue&type=script&lang=js&"
export * from "./storage-img-uploader.vue?vue&type=script&lang=js&"
import style0 from "./storage-img-uploader.vue?vue&type=style&index=0&id=74d5fbf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5fbf4",
  null
  
)

export default component.exports